<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'ASSOCIATIONS.COMPANY.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  <button mat-button mat-stroked-button class="add-association" (click)="openModal()">
    <mat-icon>add</mat-icon>
    {{ 'ASSOCIATIONS.COMPANY.ADD_COMPANY' | translate }}
  </button>
  <ng-container *ngFor="let company of companies$ | async">
    <crm-association-card
      *ngIf="company.businessName"
      [cardData]="company"
      (removeClick)="removeAssociation(company)"
      (editTagsClick)="editTags(company)"
    >
      <ng-container *ngIf="company.phone">
        <crm-common-association-card-content [iconName]="'phone'">
          <mat-card-subtitle>
            <a href="tel:{{ company.phone }}">
              {{ company.phone }}
            </a>
          </mat-card-subtitle>
        </crm-common-association-card-content>
      </ng-container>
      <ng-container *ngIf="company.tags && company.tags.length > 0">
        <crm-common-association-card-content [iconName]="'local_offer'">
          <crm-tags [tags]="company.tags"></crm-tags>
        </crm-common-association-card-content>
      </ng-container>
    </crm-association-card>
  </ng-container>
</mat-expansion-panel>
